"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AttachmentPreferencesOption_1 = require("owa-attachment-preferences-option/lib/AttachmentPreferencesOption");
var StorageAccountsOption_1 = require("owa-storage-accounts-option/lib/StorageAccountsOption");
var attachmentsSubCategory = {
    key: 'attachments',
    titleStringKey: 'optionSubcategory_attachments',
    options: [AttachmentPreferencesOption_1.default, StorageAccountsOption_1.default],
};
exports.default = attachmentsSubCategory;
//# sourceMappingURL=attachmentsSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/attachmentsSubCategory.js
// module id = 4978
// module chunks = 2